import { create } from 'zustand';

const useCityStore = create(set => ({
  selectedCity: 'New York',
  setSelectedCity: city => set({ selectedCity: city }),
}));

export default useCityStore;
